import { Directive, TemplateRef } from '@angular/core'

@Directive({
  selector: '[swimlaneColumnHeader]',
})
export class SwimlaneColumnHeaderDirective {
  constructor(public templateRef: TemplateRef<unknown>) {}
}
